export const MOCK_UNASSIGNED_PALLET_GROUPS = [
  {
    id: "pg-01",
    palletGroup: "P0012845_PO4501278",
    type: "Customer",
    inboundId: "IBD0012845",
    asn: "ASN-2609-A",
    shipToCode: "10000472",
    shipToName: "JD Sports UK — Bury",
    shipTo: "10000472\nJD Sports UK — Bury",
    po: "PO-4501278",
    pgType: "Customer",
    totalILPNs: 33,
    sortingRule: "Std palletise",
    ilpnIds: ["IL0001038600"],
  },
  {
    id: "pg-02",
    palletGroup: "P0012845_PO4501279",
    type: "Customer",
    inboundId: "IBD0012845",
    asn: "ASN-2609-A",
    shipToCode: "10000472",
    shipToName: "JD Sports UK — Bury",
    shipTo: "10000472\nJD Sports UK — Bury",
    po: "PO-4501279",
    pgType: "Customer",
    totalILPNs: 42,
    sortingRule: "Std palletise",
    ilpnIds: ["IL0001010000", "IL0001010001"],
  },
  {
    id: "pg-03",
    palletGroup: "P0012845_PO4502133_S",
    type: "Customer",
    inboundId: "IBD0012845",
    asn: "ASN-2609-B",
    shipToCode: "10000891",
    shipToName: "Foot Locker Europe — Vianen",
    shipTo: "10000891\nFoot Locker Europe — Vianen",
    po: "PO-4502133",
    pgType: "Customer",
    totalILPNs: 22,
    sortingRule: "Size sort required",
    ilpnIds: ["IL0001020000"],
  },
  {
    id: "pg-04",
    palletGroup: "P0012846_PO4503022",
    type: "Customer",
    inboundId: "IBD0012846",
    asn: "ASN-2609-D",
    shipToCode: "10001567",
    shipToName: "Intersport Deutschland — Heilbronn",
    shipTo: "10001567\nIntersport Deutschland — Heilbronn",
    po: "PO-4503022",
    pgType: "Customer",
    totalILPNs: 26,
    sortingRule: "Std palletise",
    ilpnIds: ["IL0001030000"],
  },
  {
    id: "pg-05",
    palletGroup: "P0012846_PO4503301",
    type: "Nike",
    inboundId: "IBD0012846",
    asn: "ASN-2609-F",
    shipToCode: "30001102",
    shipToName: "NDDC Herzogenaurach — DE Digital",
    shipTo: "30001102\nNDDC Herzogenaurach — DE Digital",
    po: "PO-4503301",
    pgType: "Nike",
    totalILPNs: 30,
    sortingRule: "Std palletise",
    ilpnIds: ["IL0001040000"],
  },
  {
    id: "pg-06",
    palletGroup: "P0012845_PO4502133_M",
    type: "Customer",
    inboundId: "IBD0012845",
    asn: "ASN-2609-B",
    shipToCode: "10000891",
    shipToName: "Foot Locker Europe — Vianen",
    shipTo: "10000891\nFoot Locker Europe — Vianen",
    po: "PO-4502133",
    pgType: "Customer",
    totalILPNs: 34,
    sortingRule: "Size sort required",
    ilpnIds: ["IL0001050000"],
  },
  {
    id: "pg-07",
    palletGroup: "P0012845_PO4502133_L",
    type: "Customer",
    inboundId: "IBD0012845",
    asn: "ASN-2609-B",
    shipToCode: "10000891",
    shipToName: "Foot Locker Europe — Vianen",
    shipTo: "10000891\nFoot Locker Europe — Vianen",
    po: "PO-4502133",
    pgType: "Customer",
    totalILPNs: 28,
    sortingRule: "Size sort required",
    ilpnIds: ["IL0001060000"],
  },
  {
    id: "pg-08",
    palletGroup: "P0012845_PO4502741",
    type: "Customer",
    inboundId: "IBD0012845",
    asn: "ASN-2609-C",
    shipToCode: "10001204",
    shipToName: "Zalando SE — Erfurt DC",
    shipTo: "10001204\nZalando SE — Erfurt DC",
    po: "PO-4502741",
    pgType: "Customer",
    totalILPNs: 50,
    sortingRule: "Std palletise",
    ilpnIds: ["IL0001070000"],
  },
  {
    id: "pg-09",
    palletGroup: "P0012846_PO4503188",
    type: "Customer",
    inboundId: "IBD0012846",
    asn: "ASN-2609-E",
    shipToCode: "10002090",
    shipToName: "Decathlon France — Lille",
    shipTo: "10002090\nDecathlon France — Lille",
    po: "PO-4503188",
    pgType: "Customer",
    totalILPNs: 46,
    sortingRule: "Std palletise",
    ilpnIds: ["IL0001080000"],
  },
  {
    id: "pg-10",
    palletGroup: "P0012846_PO4503302",
    type: "Nike",
    inboundId: "IBD0012846",
    asn: "ASN-2609-F",
    shipToCode: "30001102",
    shipToName: "NDDC Herzogenaurach — DE Digital",
    shipTo: "30001102\nNDDC Herzogenaurach — DE Digital",
    po: "PO-4503302",
    pgType: "Nike",
    totalILPNs: 18,
    sortingRule: "Std palletise",
    ilpnIds: ["IL0001090000"],
  },
  {
    id: "pg-11",
    palletGroup: "P0012847_PO4503812",
    type: "Customer",
    inboundId: "IBD0012847",
    asn: "ASN-2610-A",
    shipToCode: "10003011",
    shipToName: "SNIPES SE — Cologne",
    shipTo: "10003011\nSNIPES SE — Cologne",
    po: "PO-4503812",
    pgType: "Customer",
    totalILPNs: 31,
    sortingRule: "Std palletise",
    ilpnIds: ["IL0001100000", "IL0001100001"],
  },
  {
    id: "pg-12",
    palletGroup: "P0012847_PO4503577",
    type: "Customer",
    inboundId: "IBD0012847",
    asn: "ASN-2610-B",
    shipToCode: "10002744",
    shipToName: "Sports Direct — Shirebrook",
    shipTo: "10002744\nSports Direct — Shirebrook",
    po: "PO-4503577",
    pgType: "Customer",
    totalILPNs: 55,
    sortingRule: "Size sort required",
    ilpnIds: ["IL0001110000"],
  },
  {
    id: "pg-13",
    palletGroup: "P0012847_PO4503622",
    type: "Customer",
    inboundId: "IBD0012847",
    asn: "ASN-2610-B",
    shipToCode: "10002744",
    shipToName: "Sports Direct — Shirebrook",
    shipTo: "10002744\nSports Direct — Shirebrook",
    po: "PO-4503622",
    pgType: "Customer",
    totalILPNs: 40,
    sortingRule: "Std palletise",
    ilpnIds: ["IL0001120000"],
  },
  {
    id: "pg-14",
    palletGroup: "P0012848_PO4504488",
    type: "Customer",
    inboundId: "IBD0012848",
    asn: "ASN-2610-C",
    shipToCode: "30001299",
    shipToName: "NDDC Ham (UK) — Digital",
    shipTo: "30001299\nNDDC Ham (UK) — Digital",
    po: "PO-4504488",
    pgType: "Customer",
    totalILPNs: 36,
    sortingRule: "Std palletise",
    ilpnIds: ["IL0001130000", "IL0001130001"],
  },
  {
    id: "pg-15",
    palletGroup: "P0012848_PO4504510",
    type: "Nike",
    inboundId: "IBD0012848",
    asn: "ASN-2610-D",
    shipToCode: "30001299",
    shipToName: "NDDC Ham (UK) — Digital",
    shipTo: "30001299\nNDDC Ham (UK) — Digital",
    po: "PO-4504510",
    pgType: "Nike",
    totalILPNs: 24,
    sortingRule: "Std palletise",
    ilpnIds: ["IL0001140000"],
  },
  {
    id: "pg-16",
    palletGroup: "P0012848_PO4504522",
    type: "Customer",
    inboundId: "IBD0012848",
    asn: "ASN-2610-C",
    shipToCode: "10003380",
    shipToName: "Office London — Park Royal",
    shipTo: "10003380\nOffice London — Park Royal",
    po: "PO-4504522",
    pgType: "Customer",
    totalILPNs: 29,
    sortingRule: "Size sort required",
    ilpnIds: ["IL0001150000"],
  },
  {
    id: "pg-17",
    palletGroup: "P0012849_PO4505101",
    type: "Customer",
    inboundId: "IBD0012849",
    asn: "ASN-2610-E",
    shipToCode: "10004102",
    shipToName: "About You — Hamburg",
    shipTo: "10004102\nAbout You — Hamburg",
    po: "PO-4505101",
    pgType: "Customer",
    totalILPNs: 44,
    sortingRule: "Std palletise",
    ilpnIds: ["IL0001160000"],
  },
  {
    id: "pg-18",
    palletGroup: "P0012849_PO4505118",
    type: "Customer",
    inboundId: "IBD0012849",
    asn: "ASN-2610-E",
    shipToCode: "10004155",
    shipToName: "ASOS — Barnsley FC",
    shipTo: "10004155\nASOS — Barnsley FC",
    po: "PO-4505118",
    pgType: "Customer",
    totalILPNs: 52,
    sortingRule: "Std palletise",
    ilpnIds: ["IL0001170000", "IL0001170001"],
  },
  {
    id: "pg-19",
    palletGroup: "P0012849_PO4505200",
    type: "Nike",
    inboundId: "IBD0012849",
    asn: "ASN-2610-F",
    shipToCode: "30001145",
    shipToName: "NDDC Laakdal — BE Digital",
    shipTo: "30001145\nNDDC Laakdal — BE Digital",
    po: "PO-4505200",
    pgType: "Nike",
    totalILPNs: 20,
    sortingRule: "Std palletise",
    ilpnIds: ["IL0001180000"],
  },
  {
    id: "pg-20",
    palletGroup: "P0012850_PO4506012",
    type: "Customer",
    inboundId: "IBD0012850",
    asn: "ASN-2611-A",
    shipToCode: "10005001",
    shipToName: "Size? — Manchester DC",
    shipTo: "10005001\nSize? — Manchester DC",
    po: "PO-4506012",
    pgType: "Customer",
    totalILPNs: 33,
    sortingRule: "Size sort required",
    ilpnIds: ["IL0001190000"],
  },
  {
    id: "pg-21",
    palletGroup: "P0012850_PO4506025",
    type: "Customer",
    inboundId: "IBD0012850",
    asn: "ASN-2611-A",
    shipToCode: "10005001",
    shipToName: "Size? — Manchester DC",
    shipTo: "10005001\nSize? — Manchester DC",
    po: "PO-4506025",
    pgType: "Customer",
    totalILPNs: 27,
    sortingRule: "Size sort required",
    ilpnIds: ["IL0001200000"],
  },
  {
    id: "pg-22",
    palletGroup: "P0012850_PO4506100",
    type: "Customer",
    inboundId: "IBD0012850",
    asn: "ASN-2611-B",
    shipToCode: "10005220",
    shipToName: "Schuh — Livingston",
    shipTo: "10005220\nSchuh — Livingston",
    po: "PO-4506100",
    pgType: "Customer",
    totalILPNs: 41,
    sortingRule: "Std palletise",
    ilpnIds: ["IL0001210000"],
  },
  {
    id: "pg-23",
    palletGroup: "P0012851_PO4507001",
    type: "Customer",
    inboundId: "IBD0012851",
    asn: "ASN-2611-C",
    shipToCode: "10006088",
    shipToName: "JD Sports — Kingsway",
    shipTo: "10006088\nJD Sports — Kingsway",
    po: "PO-4507001",
    pgType: "Customer",
    totalILPNs: 48,
    sortingRule: "Std palletise",
    ilpnIds: ["IL0001220000", "IL0001220001"],
  },
  {
    id: "pg-24",
    palletGroup: "P0012851_PO4507015",
    type: "Nike",
    inboundId: "IBD0012851",
    asn: "ASN-2611-D",
    shipToCode: "30001102",
    shipToName: "NDDC Herzogenaurach — DE Digital",
    shipTo: "30001102\nNDDC Herzogenaurach — DE Digital",
    po: "PO-4507015",
    pgType: "Nike",
    totalILPNs: 16,
    sortingRule: "Std palletise",
    ilpnIds: ["IL0001230000"],
  },
  {
    id: "pg-25",
    palletGroup: "P0012851_PO4507102",
    type: "Customer",
    inboundId: "IBD0012851",
    asn: "ASN-2611-C",
    shipToCode: "10006201",
    shipToName: "Footasylum — Rochdale",
    shipTo: "10006201\nFootasylum — Rochdale",
    po: "PO-4507102",
    pgType: "Customer",
    totalILPNs: 35,
    sortingRule: "Size sort required",
    ilpnIds: ["IL0001240000"],
  },
  {
    id: "pg-26",
    palletGroup: "P0012852_PO4508200",
    type: "Customer",
    inboundId: "IBD0012852",
    asn: "ASN-2612-A",
    shipToCode: "10007010",
    shipToName: "River Island — Milton Keynes",
    shipTo: "10007010\nRiver Island — Milton Keynes",
    po: "PO-4508200",
    pgType: "Customer",
    totalILPNs: 39,
    sortingRule: "Std palletise",
    ilpnIds: ["IL0001250000"],
  },
  {
    id: "pg-27",
    palletGroup: "P0012852_PO4508211",
    type: "Customer",
    inboundId: "IBD0012852",
    asn: "ASN-2612-A",
    shipToCode: "10007122",
    shipToName: "H&M Online — Gelsenkirchen",
    shipTo: "10007122\nH&M Online — Gelsenkirchen",
    po: "PO-4508211",
    pgType: "Customer",
    totalILPNs: 58,
    sortingRule: "Std palletise",
    ilpnIds: ["IL0001260000"],
  },
  {
    id: "pg-28",
    palletGroup: "P0012852_PO4508305",
    type: "Nike",
    inboundId: "IBD0012852",
    asn: "ASN-2612-B",
    shipToCode: "30001145",
    shipToName: "NDDC Laakdal — BE Digital",
    shipTo: "30001145\nNDDC Laakdal — BE Digital",
    po: "PO-4508305",
    pgType: "Nike",
    totalILPNs: 22,
    sortingRule: "Std palletise",
    ilpnIds: ["IL0001270000"],
  },
];

/** Pallet groups assigned to a spur (Multiple PGs modal). */
export const MOCK_SPUR_ASSIGNED_PGS = {
  "16-01-003-0-00": [
    {
      id: "spg-16-01-003-a",
      palletGroup: "P0012848_STO9001233",
      asn: "ASN-2609-J",
      shipToCode: "30001177",
      shipToName: "Nike Store — London Oxford St",
      po: "STO-9001233",
      totalILPNs: 20,
      diverted: 10,
      palletised: 6,
      sortingRule: "Std palletise",
      type: "Nike",
      pgType: "Nike",
      ilpnIds: ["IL0001160000"],
    },
    {
      id: "spg-16-01-003-b",
      palletGroup: "P0012848_STO9001411",
      asn: "ASN-2609-K",
      shipToCode: "30001208",
      shipToName: "Nike Store — Berlin Alexanderplatz",
      po: "STO-9001411",
      totalILPNs: 14,
      diverted: 6,
      palletised: 4,
      sortingRule: "Std palletise",
      type: "Nike",
      pgType: "Nike",
      ilpnIds: ["IL0001170000"],
    },
  ],
  "16-01-012-0-00": [
    {
      id: "spg-16-01-012-a",
      palletGroup: "P0012847_PO4504019_S",
      asn: "ASN-2609-H",
      shipToCode: "10003589",
      shipToName: "ProDirect Soccer — Dartford",
      po: "PO-4504019",
      totalILPNs: 12,
      diverted: 12,
      palletised: 12,
      sortingRule: "Size sort required",
      type: "Customer",
      pgType: "Customer",
      ilpnIds: ["IL0001190000"],
    },
    {
      id: "spg-16-01-012-b",
      palletGroup: "P0012847_PO4504019_M",
      asn: "ASN-2609-H",
      shipToCode: "10003589",
      shipToName: "ProDirect Soccer — Dartford",
      po: "PO-4504019",
      totalILPNs: 18,
      diverted: 18,
      palletised: 7,
      sortingRule: "Size sort required",
      type: "Customer",
      pgType: "Customer",
      ilpnIds: ["IL0001200000"],
    },
    {
      id: "spg-16-01-012-c",
      palletGroup: "P0012847_PO4504019_L",
      asn: "ASN-2609-H",
      shipToCode: "10003589",
      shipToName: "ProDirect Soccer — Dartford",
      po: "PO-4504019",
      totalILPNs: 16,
      diverted: 16,
      palletised: 0,
      sortingRule: "Size sort required",
      type: "Customer",
      pgType: "Customer",
      ilpnIds: ["IL0001210000"],
    },
  ],
  "16-01-014-0-00": [
    {
      id: "spg-16-01-014-a",
      palletGroup: "P0012851_PO4507001",
      asn: "ASN-2610-A",
      shipToCode: "10006088",
      shipToName: "JD Sports — Kingsway",
      po: "PO-4507001",
      totalILPNs: 48,
      diverted: 48,
      palletised: 45,
      sortingRule: "Std palletise",
      type: "Customer",
      pgType: "Customer",
      ilpnIds: ["IL0001220000"],
    },
    {
      id: "spg-16-01-014-b",
      palletGroup: "P0012851_PO4507015",
      asn: "ASN-2610-B",
      shipToCode: "10004155",
      shipToName: "ASOS — Barnsley FC",
      po: "PO-4507015",
      totalILPNs: 35,
      diverted: 35,
      palletised: 26,
      sortingRule: "Std palletise",
      type: "Customer",
      pgType: "Customer",
      ilpnIds: ["IL0001230000"],
    },
  ],
  "16-02-013-0-00": [
    {
      id: "spg-16-02-013-a",
      palletGroup: "P0012846_PO4503188",
      asn: "ASN-2609-E",
      shipToCode: "10002090",
      shipToName: "Decathlon France — Lille",
      po: "PO-4503188",
      totalILPNs: 46,
      diverted: 40,
      palletised: 22,
      sortingRule: "Std palletise",
      type: "Customer",
      pgType: "Customer",
      ilpnIds: ["IL0001240000"],
    },
    {
      id: "spg-16-02-013-b",
      palletGroup: "P0012846_PO4503301",
      asn: "ASN-2609-F",
      shipToCode: "30001102",
      shipToName: "NDDC Herzogenaurach — DE Digital",
      po: "PO-4503301",
      totalILPNs: 30,
      diverted: 28,
      palletised: 18,
      sortingRule: "Std palletise",
      type: "Nike",
      pgType: "Nike",
      ilpnIds: ["IL0001250000"],
    },
    {
      id: "spg-16-02-013-c",
      palletGroup: "P0012846_PO4503302",
      asn: "ASN-2609-F",
      shipToCode: "30001102",
      shipToName: "NDDC Herzogenaurach — DE Digital",
      po: "PO-4503302",
      totalILPNs: 18,
      diverted: 15,
      palletised: 12,
      sortingRule: "Std palletise",
      type: "Nike",
      pgType: "Nike",
      ilpnIds: ["IL0001260000"],
    },
    {
      id: "spg-16-02-013-d",
      palletGroup: "P0012847_PO4503622",
      asn: "ASN-2610-C",
      shipToCode: "10002744",
      shipToName: "Sports Direct — Shirebrook",
      po: "PO-4503622",
      totalILPNs: 18,
      diverted: 12,
      palletised: 8,
      sortingRule: "Size sort required",
      type: "Customer",
      pgType: "Customer",
      ilpnIds: ["IL0001270000"],
    },
  ],
};

export const MOCK_SPUR_SUMMARY = [
  {
    id: "s1",
    spur: "16-01-003-0-00",
    spurType: "P",
    spurStatus: "Assigned",
    palletGroup: "Multiple PGs (2)",
    palletGroupCount: 2,
    inboundId: "IBD0012848",
    totalCartons: 34,
    diverted: 17,
    palletised: 10,
    receivingZone: "Receiving 1",
    shipTo: "Mixed (2)",
    readyToComplete: false,
  },
  {
    id: "s2",
    spur: "16-01-012-0-00",
    spurType: "P",
    spurStatus: "Assigned",
    palletGroup: "Multiple PGs (3)",
    palletGroupCount: 3,
    inboundId: "Mixed (2)",
    totalCartons: 46,
    diverted: 46,
    palletised: 46,
    receivingZone: "Receiving 1",
    shipTo: "Mixed (3)",
    readyToComplete: true,
  },
  {
    id: "s3",
    spur: "16-01-018-0-00",
    spurType: "P",
    spurStatus: "Assigned",
    palletGroup: "P0012847_PO4503812",
    palletGroupCount: 1,
    inboundId: "IBD0012847",
    totalCartons: 24,
    diverted: 24,
    palletised: 24,
    receivingZone: "Receiving 1",
    shipTo: "10003011\nSNIPES SE — Cologne",
    shipToCode: "10003011",
    shipToName: "SNIPES SE — Cologne",
    readyToComplete: true,
  },
  {
    id: "s4",
    spur: "16-02-004-0-00",
    spurType: "P",
    spurStatus: "Assigned",
    palletGroup: "P0012848_PO4504488",
    palletGroupCount: 1,
    inboundId: "IBD0012848",
    totalCartons: 32,
    diverted: 29,
    palletised: 22,
    receivingZone: "Receiving 2",
    shipTo: "30001299\nNDDC Ham (UK) — Digital",
    shipToCode: "30001299",
    shipToName: "NDDC Ham (UK) — Digital",
    readyToComplete: false,
  },
  {
    id: "s5",
    spur: "16-02-009-0-00",
    spurType: "P",
    spurStatus: "Suspended",
    palletGroup: "P0012847_PO4503577",
    palletGroupCount: 1,
    inboundId: "IBD0012847",
    totalCartons: 60,
    diverted: 18,
    palletised: 6,
    receivingZone: "Receiving 2",
    shipTo: "10002744\nSports Direct — Shirebrook",
    shipToCode: "10002744",
    shipToName: "Sports Direct — Shirebrook",
    readyToComplete: false,
  },
  {
    id: "s6",
    spur: "16-01-001-0-00",
    spurType: "P",
    spurStatus: "Idle",
    palletGroup: "—",
    palletGroupCount: 0,
    inboundId: "—",
    totalCartons: 0,
    diverted: 0,
    palletised: 0,
    receivingZone: "Receiving 1",
    shipTo: "—",
    readyToComplete: false,
  },
  {
    id: "s7",
    spur: "16-01-005-0-00",
    spurType: "P",
    spurStatus: "Idle",
    palletGroup: "—",
    palletGroupCount: 0,
    inboundId: "—",
    totalCartons: 0,
    diverted: 0,
    palletised: 0,
    receivingZone: "Receiving 1",
    shipTo: "—",
    readyToComplete: false,
  },
  {
    id: "s8",
    spur: "16-01-007-0-00",
    spurType: "P",
    spurStatus: "Assigned",
    palletGroup: "P0012849_PO4505101",
    palletGroupCount: 1,
    inboundId: "IBD0012849",
    totalCartons: 44,
    diverted: 44,
    palletised: 38,
    receivingZone: "Receiving 1",
    shipTo: "10004102\nAbout You — Hamburg",
    shipToCode: "10004102",
    shipToName: "About You — Hamburg",
    readyToComplete: false,
  },
  {
    id: "s9",
    spur: "16-01-009-0-00",
    spurType: "P",
    spurStatus: "Assigned",
    palletGroup: "P0012850_PO4506012",
    palletGroupCount: 1,
    inboundId: "IBD0012850",
    totalCartons: 33,
    diverted: 20,
    palletised: 12,
    receivingZone: "Receiving 1",
    shipTo: "10005001\nSize? — Manchester DC",
    shipToCode: "10005001",
    shipToName: "Size? — Manchester DC",
    readyToComplete: false,
  },
  {
    id: "s10",
    spur: "16-01-014-0-00",
    spurType: "P",
    spurStatus: "Assigned",
    palletGroup: "Multiple PGs (2)",
    palletGroupCount: 2,
    inboundId: "IBD0012851",
    totalCartons: 83,
    diverted: 83,
    palletised: 71,
    receivingZone: "Receiving 1",
    shipTo: "Mixed (2)",
    readyToComplete: true,
  },
  {
    id: "s11",
    spur: "16-01-016-0-00",
    spurType: "P",
    spurStatus: "Suspended",
    palletGroup: "P0012845_PO4502741",
    palletGroupCount: 1,
    inboundId: "IBD0012845",
    totalCartons: 50,
    diverted: 12,
    palletised: 4,
    receivingZone: "Receiving 1",
    shipTo: "10001204\nZalando SE — Erfurt DC",
    shipToCode: "10001204",
    shipToName: "Zalando SE — Erfurt DC",
    readyToComplete: false,
  },
  {
    id: "s12",
    spur: "16-02-001-0-00",
    spurType: "P",
    spurStatus: "Idle",
    palletGroup: "—",
    palletGroupCount: 0,
    inboundId: "—",
    totalCartons: 0,
    diverted: 0,
    palletised: 0,
    receivingZone: "Receiving 2",
    shipTo: "—",
    readyToComplete: false,
  },
  {
    id: "s13",
    spur: "16-02-006-0-00",
    spurType: "P",
    spurStatus: "Assigned",
    palletGroup: "P0012849_PO4505118",
    palletGroupCount: 1,
    inboundId: "IBD0012849",
    totalCartons: 52,
    diverted: 52,
    palletised: 52,
    receivingZone: "Receiving 2",
    shipTo: "10004155\nASOS — Barnsley FC",
    shipToCode: "10004155",
    shipToName: "ASOS — Barnsley FC",
    readyToComplete: true,
  },
  {
    id: "s14",
    spur: "16-02-011-0-00",
    spurType: "P",
    spurStatus: "Assigned",
    palletGroup: "P0012852_PO4508211",
    palletGroupCount: 1,
    inboundId: "IBD0012852",
    totalCartons: 58,
    diverted: 41,
    palletised: 28,
    receivingZone: "Receiving 2",
    shipTo: "10007122\nH&M Online — Gelsenkirchen",
    shipToCode: "10007122",
    shipToName: "H&M Online — Gelsenkirchen",
    readyToComplete: false,
  },
  {
    id: "s15",
    spur: "16-02-013-0-00",
    spurType: "P",
    spurStatus: "Assigned",
    palletGroup: "Multiple PGs (4)",
    palletGroupCount: 4,
    inboundId: "Mixed (3)",
    totalCartons: 112,
    diverted: 95,
    palletised: 60,
    receivingZone: "Receiving 2",
    shipTo: "Mixed (4)",
    readyToComplete: false,
  },
  {
    id: "s16",
    spur: "16-01-020-0-00",
    spurType: "P",
    spurStatus: "Idle",
    palletGroup: "—",
    palletGroupCount: 0,
    inboundId: "—",
    totalCartons: 0,
    diverted: 0,
    palletised: 0,
    receivingZone: "Receiving 1",
    shipTo: "—",
    readyToComplete: false,
  },
  {
    id: "s17",
    spur: "16-02-015-0-00",
    spurType: "P",
    spurStatus: "Suspended",
    palletGroup: "P0012846_PO4503188",
    palletGroupCount: 1,
    inboundId: "IBD0012846",
    totalCartons: 46,
    diverted: 30,
    palletised: 8,
    receivingZone: "Receiving 2",
    shipTo: "10002090\nDecathlon France — Lille",
    shipToCode: "10002090",
    shipToName: "Decathlon France — Lille",
    readyToComplete: false,
  },
  {
    id: "s18",
    spur: "16-01-022-0-00",
    spurType: "P",
    spurStatus: "Assigned",
    palletGroup: "P0012851_PO4507001",
    palletGroupCount: 1,
    inboundId: "IBD0012851",
    totalCartons: 48,
    diverted: 48,
    palletised: 45,
    receivingZone: "Receiving 1",
    shipTo: "10006088\nJD Sports — Kingsway",
    shipToCode: "10006088",
    shipToName: "JD Sports — Kingsway",
    readyToComplete: true,
  },
];
